import styled from "styled-components";

export const WalletPubListItemWrapper = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  height: ${(p) => (!p.isSelected ? "43px" : "107px")};
  transition: height 0.3s ease-in-out;
  overflow: hidden;
  padding: 10px 10px 17px;
  box-sizing: border-box;
  justify-content: space-between;
`;

export const WalletPubListItemTopWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const WalletPubListItemPubPoint = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  > .point {
    font-weight: 600;
    font-size: 14px;
    color: #121212;
    display: flex;
    align-items: center;
    gap: 3px;

    > span {
      color: #808080;
    }
  }
`;

export const WalletPubListItemPub = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;

  > img {
    width: 23px;
    height: 23px;
    border-radius: 50%;
  }

  > .name {
    font-weight: 600;
    font-size: 14px;
  }
`;

export const WalletPubListItemInfoWrapper = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  height: 45px;
  border-radius: 8px;
  background: #f0f0f0;
  opacity: ${(p) => (p.isSelected ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const WalletPubListItemInfo = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > .name {
    font-weight: 400;
    font-size: 9px;
    text-align: center;
    color: #121212;
  }
  > .value {
    font-weight: 700;
    font-size: 10px;
    text-align: center;
    text-decoration: underline;
    color: #6436e7;
  }
`;
